exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root{--ck-color-mention-background:rgba(255,219,77,0.5);--ck-color-mention-text:#343104}", ""]);
